import React from 'react';
import { Loader } from "semantic-ui-react";
import { useFeatureFlag } from "./FeatureFlagContext";
export function FeatureFlagWrapper(props) {
    const { enabled, loading } = useFeatureFlag(props.flagName);
    if (loading) {
        return React.createElement(Loader, { active: true, inline: "centered" });
    }
    if (enabled) {
        return React.createElement(React.Fragment, null, props.children);
    }
    return React.createElement(React.Fragment, null);
}
